<h1 id="lista" [translation]="TranslationEnum.Translation" *ngIf = "!Valuation">
  {{'lista'|translate}}
  <!-- <app-tlumacz [id]="'lista'" [typ]="'zmienne'" [tresci]="tresci"></app-tlumacz> -->
</h1>
<h1 id="listawycen" [translation]="TranslationEnum.Translation" *ngIf = "Valuation">
  {{'listawycen'|translate}}
  <!-- <app-tlumacz [id]="'lista'" [typ]="'zmienne'" [tresci]="tresci"></app-tlumacz> -->
</h1>
<mat-checkbox color="primary" class=" m-2 valuation_{{Valuation}} pokaz_{{pokazWszystkieZam}}" #isMineOrders [(ngModel)]="IsMineOrders" (change)="refresh();">
  <label id="czymojezam" class="pokaz_{{pokazWszystkieZam}}" [translation]="TranslationEnum.Translation">
    {{'czymojezam'|translate}}
  </label>
  <!-- <app-tlumacz [id]="'CzyMojeZam'" [typ]="'stale'" [tresci]="tresci"></app-tlumacz> -->
</mat-checkbox>
<mat-checkbox *ngIf = "(IsTrader || CreateComplaintOrder)" color="primary" class=" m-2 valuation_{{Valuation}}"  [(ngModel)]="ShowComplaints" (change)="refresh();">
  <label id="czyreklamacja" [translation]="TranslationEnum.Translation">
    {{'czyreklamacja'|translate}}
  </label>
</mat-checkbox>



<mat-tab-group  [selectedIndex]="selected_id" animationDuration="0ms" class="d-inline valuationtab_{{Valuation}}">
  <mat-tab *ngIf="!BlockingB2B"  label="First">
    <ng-template mat-tab-label>
      <span id="opracowywane" [translation]="TranslationEnum.Translation">
        {{'opracowywane'|translate}}
      </span>
      {{StatuesQuantity.Opracowywane !== 0 ? '(' + StatuesQuantity.Opracowywane + ')': ''}}
    </ng-template>
    <ng-template matTabContent>
      <app-order-list [status]="+StatusEnum.Opracowywane" [refresh]="refreshRegister"
        [IsSaleBlocked]="IsSaleBlocked" [isMineOrders]="isMineOrders.checked" [ShowComplaints] = "ShowComplaints" [dateFrom]="dateFrom" [dateTo]="dateTo"></app-order-list>
    </ng-template>
  </mat-tab>
  <mat-tab *ngIf="!BlockingB2B && StatuesQuantity.Przekazane > 0"  label="Przekazano">
    <ng-template mat-tab-label>
      <span id="przekazane" [translation]="TranslationEnum.Translation">
        {{'przekazane'|translate}}
      </span>
      {{StatuesQuantity.Przekazane !== 0 ? '(' + StatuesQuantity.Przekazane + ')': ''}}
    </ng-template>
    <ng-template matTabContent>
      <app-order-list [status]="+StatusEnum.Przekazane" [refresh]="refreshRegister"
        [IsSaleBlocked]="IsSaleBlocked" [isMineOrders]="isMineOrders.checked" [ShowComplaints] = "ShowComplaints" [dateFrom]="dateFrom" [dateTo]="dateTo"></app-order-list>
    </ng-template>
  </mat-tab>
  <mat-tab *ngIf="!BlockingB2B && !Valuation"  label="zamowiono">
    <ng-template mat-tab-label>
      <span id="zamowiono" [translation]="TranslationEnum.Translation">
        {{'zamowiono'|translate}}
      </span>
      {{StatuesQuantity.Zamowiono !== 0 ? '(' + StatuesQuantity.Zamowiono + ')': ''}}
    </ng-template>
    <ng-template matTabContent>
      <app-order-list [status]="+StatusEnum.Zamowiono" [refresh]="refreshRegister" [isMineOrders]="isMineOrders.checked" [ShowComplaints] = "ShowComplaints"
         [IsSaleBlocked]="IsSaleBlocked" [dateFrom]="dateFrom" [dateTo]="dateTo"></app-order-list>
    </ng-template>
  </mat-tab>
  <mat-tab *ngIf="!BlockingB2B && !Valuation" label="realizacja">
    <ng-template mat-tab-label>
      <span id="realizacja" [translation]="TranslationEnum.Translation">
        {{'realizacja'|translate}}
      </span>
      {{StatuesQuantity.Realizacja !== 0 ? '(' + StatuesQuantity.Realizacja + ')': ''}}
    </ng-template>
    <ng-template matTabContent>
      <app-order-list [status]="+StatusEnum.Realizacja" [refresh]="refreshRegister"
         [IsSaleBlocked]="IsSaleBlocked" [isMineOrders]="isMineOrders.checked" [ShowComplaints] = "ShowComplaints" [dateFrom]="dateFrom" [dateTo]="dateTo"></app-order-list>
    </ng-template>
  </mat-tab>
  <mat-tab *ngIf="!BlockingB2B && !Valuation" label="wstrzymano">
    <ng-template mat-tab-label>
      <span id="wstrzymano" [translation]="TranslationEnum.Translation">
        {{'wstrzymano'|translate}}
      </span>
      {{StatuesQuantity.Wstrzymano !== 0 ? '(' + StatuesQuantity.Wstrzymano + ')': ''}}
    </ng-template>
    <ng-template matTabContent>
      <app-order-list [status]="+StatusEnum.Wstrzymano" [refresh]="refreshRegister"
        [IsSaleBlocked]="IsSaleBlocked" [isMineOrders]="isMineOrders.checked" [ShowComplaints] = "ShowComplaints" [dateFrom]="dateFrom" [dateTo]="dateTo"></app-order-list>
    </ng-template>
  </mat-tab>
  <mat-tab *ngIf="!BlockingB2B && !Valuation" label="zakonczono">
    <ng-template mat-tab-label>
      <span id="zakonczono" [translation]="TranslationEnum.Translation">
        {{'zakonczono'|translate}}
      </span>
      {{StatuesQuantity.Zakonczono !== 0 ? '(' + StatuesQuantity.Zakonczono + ')': ''}}
    </ng-template>
    <ng-template matTabContent>
      <app-order-list [status]="+StatusEnum.Zakonczono" [refresh]="refreshRegister"
        [IsSaleBlocked]="IsSaleBlocked"  [isMineOrders]="isMineOrders.checked" [ShowComplaints] = "ShowComplaints" [dateFrom]="dateFrom" [dateTo]="dateTo"></app-order-list>
    </ng-template>
  </mat-tab>
  <mat-tab *ngIf="!BlockingB2B && !Valuation" label="anulowano">
    <ng-template mat-tab-label>
      <span id="anulowano" [translation]="TranslationEnum.Translation">
        {{'anulowano'|translate}}
      </span>
      {{StatuesQuantity.Anulowano !== 0 ? '(' + StatuesQuantity.Anulowano + ')': ''}}
    </ng-template>
    <ng-template matTabContent>
      <app-order-list [status]="+StatusEnum.Anulowano" [refresh]="refreshRegister" [isMineOrders]="isMineOrders.checked" [ShowComplaints] = "ShowComplaints"
         [IsSaleBlocked]="IsSaleBlocked" [dateFrom]="dateFrom" [dateTo]="dateTo"></app-order-list>
    </ng-template>
  </mat-tab>
  <mat-tab *ngIf="canOrder && !BlockingB2B && !Valuation"  label="platnosci">
    <ng-template mat-tab-label>
      <span id="platnosci" [translation]="TranslationEnum.Translation">
        {{'platnosci'|translate}}
      </span>
      {{StatuesQuantity.Platnosci !== 0 ? '(' + StatuesQuantity.Platnosci + ')': ''}}
    </ng-template>
    <ng-template matTabContent>
      <app-proforms-list [isMineOrders]="isMineOrders.checked" [dateFrom]="dateFrom" [dateTo]="dateTo" [refresh]="refreshRegister">
      </app-proforms-list>
    </ng-template>
  </mat-tab>
  <mat-tab *ngIf="canOrder && EnableEWdt && !Valuation" label="ewdt">
    <ng-template mat-tab-label>
      <span id="potwierdzenie_e-wdt" [translation]="TranslationEnum.Translation">
        {{'potwierdzenie_e-wdt'|translate}}
      </span>
    </ng-template>
    <ng-template matTabContent>
      <app-delivery-list [refresh]="refreshRegister" [isMineOrders]="isMineOrders.checked" [dateFrom]="dateFrom" [dateTo]="dateTo"></app-delivery-list>
    </ng-template>
  </mat-tab>
  
  <mat-tab *ngIf="canOrder && !BlockingB2B && !Valuation"  label="route">
    <ng-template mat-tab-label>
      <span id="routes" [translation]="TranslationEnum.Translation">
        {{'routes'|translate}}
      </span>
      
    </ng-template>
    <ng-template matTabContent>
      <app-route-list>
      </app-route-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>

